import Dexie from 'dexie';

const db = new Dexie('OLFabrica');

// Tabelas com {Local} não existem na nuvem, e são normalmente usadas apenas para reexibição.

db.version(48).stores({
  usuario: `
  ++id, 
  useidnuvem, 
  usenome, 
  usecpf, 
  usesenha, 
  usedataalteracao
  `,
  apontamentoproducaolocal: `
  ++id,
  appidnuvem,
  appordemproducao,
  appdata, applote,
  appturno,
  appprodutodescricao,
  appgranulometria,
  appdatainicio,
  apptimeinicio,
  appquantidade,
  appembalagem,
  appdescricaoembalagem, 
  appquantidadeembalagem,
  apploteembalagem,
  applocalarmazenamento,
  appdescricaolocalarmazenamento,
  appdatatermino,
  apptimetermino,
  appestado,
  appidfabrica
  `,
  apontamentoproducao: `
  ++id,
  appidnuvem,
  appdatanuvem,
  appidproducao,
  appidaberturalote,
  appidturno,
  appidproduto,
  appdatainicio,
  appquantidade,
  appquantidadeembalagem,
  appidaberturaloteembalagem,
  appidapontamentonuvemlocal,
  appidlocalarmazenamento,
  appdatatermino,
  appdataalteracao,
  appidapontamentolocal,
  appdatapesagem,
  appobsduplicado,
  appstatus,
  apppeso,
  appidlocaltransferenciaproducao,
  appidlocalmovimentacaoestoque,
  appidfabrica,
  appemprocesso,
  appdataprocesso`
  ,
  aberturalote: `
  ++id,
  ablidnuvem,
  ablidaberturalote,
  ablnrocontrole,
  abldescricao,
  ablgranulometria,
  abldataalteracao,
  ablidordemproducao,
  abldataabertura,
  ablidfabrica,
  ablidproduto,
  ablsecagem,
  ablcodigodun
  `
  ,
  turno: `
  ++id,
  tupidnuvem,
  tupidturno,
  tupdataabertura,
  tupdatafechamento,
  tupobservacao,
  tupdataalteracao`
  ,
  localarmazenamento: `
  ++id,
  loaidnuvem,
  loaidlocalarmazenamento,
  loadescricao,
  loadataalteracao,
  loacodigoarmazem,
  loausadoapppesagem`
  ,
  produto: `
  ++id,
  proidnuvem,
  prodescricao,
  proidproduto,
  prodataalteracao,
  progranulometria,
  proidvariedade`
  ,
  fabrica: `
  ++id,
  fabidnuvem,
  fabidfabrica,
  fabdescricao,
  fabdataalteracao`
  ,
  producao: `
  ++id,
  prcidnuvem,
  prcidproducao,
  prcidfabrica,
  prcdatafechamento,
  prcdataabertura,
  prcobservacao,
  prcnoordemproducao,
  prcdataalteracao`
  ,
  variedade: `
  ++id,
  varidnuvem,
  varidvariedade,
  vardescricao,
  vardataalteracao
  `,
  logexclusao: `
  ++id,
  loedataexclusao
`,
  secagem: `
  ++id,
  secidnuvem,
  secdatanuvem,
  secdataalteracao,
  secdatainicio,
  secdatatermino,
  sectempooperacao,
  sectipooperacao,
  secidusuario,
  secidsecagem,
  secidlocalmovimentacaoestoque,
  secsecador,
  secidsecador,
  secstatus,
  secumidade,
  secumidadefinal,
  sectemperaturaar,
  secumidadear,
  secpesoentrada
`,
  abastecimentosecagem: `
  ++id,
  absidnuvem,
  absidabastecimentosecagem,
  absidaberturalote,
  absidusuario,
  absidsecador,
  absidsecagem,
  abssecagem,
  absdatainicio,
  absdatatermino,
  absdataalteracao,
  absdeletar
`,
  secador: `
  ++id,
  scdidnuvem,
  scdidsecador,
  scdstatus,
  scdperdaumidadehora,
  scdperdaumidadepercentual,
  scddataalteracao
`,
  operacao: `
  ++id,
  opeidnuvem,
  opeidoperacao,
  opeidsecador,
  opetipo,
  opepeso,
  opeumidade,
  opeumidadear,
  opetemperaturaar,
  opedatainicio,
  opedatatermino,
  opesecagem
`,
  amostra: `
  ++id,
  amoidnuvem,
  amodatanuvem,
  amoidamostra,
  amodataamostra,
  amostatus,
  amofluxoar,
  amoumidadecima,
  amoumidademeio,
  amoumidadebaixo,
  amoumidade,
  amoobservacao,
  amoidusuario,
  amooperador,
  amodatastatus,
  amoidoperacao,
  amodataoperacao,
  amodataalteracao
`,
apontamentotransferenciamovimentacao: `
++id,
atmidnuvem,
atmidlocalmovtoorigem,
atmidlocalmovtodestino,
atmdata,
atmidusuario,
atmdataalteracao,
atmdatanuvem,
atmidturno
`,
apontamentoconsumomovimentacao: `
++id,
acmidnuvem,
acmidfabricadestino,
acmidturno,
acmidusuario,
acmdata,
acmdataalteracao,
acmdatanuvem
`,
ordemcarregamento: `
++id,
orcidnuvem,
orcdatanuvem,
orcidordemcarregamento,
orcidveiculo,
orcplaca,
orcplacacomplementar1,
orcplacacomplementar2,
orcidpessoatransportador,
orcidpessoamotorista,
orcobservacao,
orcidusuarioordem,
orcdataordem,
orcdataalteracao,
orcdatafinalizado,
orcmarca,
orctransportador,
orcmotorista,
orctipomercado,
orcdatainicio,
orcidusuarioiniciou,
orcidusuariofinalizou,
orcidlocalmovimentacaoestoque,
orcdoca,
orcarmazem,
orcdatafaturamento
`,
ordemcarregamentoitem: `
++id,
ociidnuvem,
ociidordemcarregamentoitem,
ociidordemcarregamento,
ociquantidade,
ociidcliente,
ocicliente,
ociidproduto,
ociproduto,
ociprodutocodigo,
ocidataalteracao,
ocidatanuvem,
ocidatafinalizado,
ocidatacriacao,
ociverificaunidade,
ociun
`,
ordemcarregamentounidade: `
  ++id,
  ocuidnuvem,
  ocuidordemcarregamentounidade,
  ocuidordemcarregamentoitem,
  ocuidaberturalote,
  ocuidlocalmovimentacaoestoque,
  ocunumerobag,
  oculote,
  oculocal,
  ocuquantidade,
  ocudataalteracao,
  ocudatanuvem,
  ocudatafinalizado,
  ocudatacriacao,
  ocuorigem,
  ocuexclusao
`,
imagem: `
  ++id,
  tentativa,
  relacao,
  base64,
  rotaapi,
  datacriacao,
  nomearquivo
`,
processo: 'key',
empresa: `
  ++id,
  empidnuvem,
  empidempresa,
  empnome,
  empcnpj,
  empsafra,
  empdominiochecklist,
  empdataalteracao
`,
// {Local} CACHE DAS PERMISSÕES DE MENU POR USUÁRIO, GRAVADO QUANDO ONLINE PARA USO OFFLINE
permissaolocal: `
  [useidnuvem+rotina],
  useidnuvem
`,
// ----- Checklist offline: espelhos das tabelas de formulário -----
formulario: `
  ++id,
  foridnuvem,
  fororigemtipo,
  fororigemid,
  fornome,
  fordatacadastro,
  fordatafinalizado,
  fordataalteracao
`,
formularioquestao: `
  ++id,
  foqidnuvem,
  foqidformularionuvem,
  foqidformularioquestaonuvem,
  foqordem,
  foqdataalteracao
`,
formularioquestaoopcao: `
  ++id,
  fqoidnuvem,
  fqoidformularioquestaonuvem,
  fqoordem,
  fqodataalteracao
`,
formularioidentificacao: `
  ++id,
  foiidnuvem,
  foridformulario,
  foidataalteracao
`,
// Prefixo `frs` para não colidir com `for` do formulário.
formularioresposta: `
  ++id,
  frsidnuvem,
  frsidformularioidentificacao,
  frsidformularioquestao,
  frsdataalteracao
`,
// {Local} Fila de envio do checklist.
formularioenvio: `
  ++id,
  fenidformulario,
  fenchaveenvio,
  fendatagravacao,
  fendatanuvem,
  fenemprocesso,
  fendataprocesso,
  fenproximatentativa,
  fenfalhapermanente,
  fenconflito
`,
// {Local} Anexos pendentes (Blob).
formularioenvioarquivo: `
  ++id,
  faeidenvio,
  faequestao
`

});

db.open().then(function (db) {
  console.log('db | aberto: ', db);
}).catch (function (err) {
  console.log('db | erro: ', err)
});

// ORDERPRODUCAO?


export default db;


/* 
OP
DATA
LOTE
TURNO
DESCRICAO - LOTE
GRANULOMETRIA
INICIO PROD
QUANTIDADE
EMBALAGEM
EMBLALAGEM
DESCRICAO - LOTE EMBALAGEM
QUANTIDADE EMBALAGEM
LOCAL ARMAZENAMENTO
DESCRICAO LOCAL
TERMINO PROD
*/